module.exports = __webpack_public_path__ + "img/Black-Jack-new.9b60d80.png";